import React from 'react'
import { Control, Controller, ControllerRenderProps } from 'react-hook-form'
import { ToggleButton, ToggleButtonProps } from '@material-ui/lab'
import { makeStyles, Typography } from '@material-ui/core'

type Props = ToggleButtonProps & {
  control: Control
  name: string
  label: string
  disabled?: boolean
}

const useStyles = makeStyles(() => ({
  toggleButtonSelected: {
    '&.MuiToggleButton-root': {
      color: 'black',
    },
  },
}))

export function ControlledToggleButton(props: Props): React.ReactElement {
  const { control, name, label, disabled, ...toggleButtonProps } = props

  const classes = useStyles()

  return (
    <Controller
      control={control}
      name={name}
      render={({
        value,
        onChange,
      }: Omit<ControllerRenderProps, 'value'> & { value: boolean }) => (
        <ToggleButton
          classes={{ selected: classes.toggleButtonSelected }}
          {...toggleButtonProps}
          name={name}
          value={value}
          selected={value}
          disabled={disabled}
          onChange={(event) =>
            onChange(!JSON.parse(event.currentTarget.ariaPressed ?? 'false'))
          }
        >
          <Typography>{label}</Typography>
        </ToggleButton>
      )}
    />
  )
}
